<template>
  <div class="load-more-preload">
    <span></span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {
  name: "LoadMorePreload"
};
</script>

<style lang="scss">
@import "../styles/part/variables";

.load-more-preload {
  display: flex;
  justify-content: center;
  margin: 0 auto -1px;
  padding: 14px 0;
}

$d: 1;

.load-more-preload span {
  margin: 0 3px;
  border: 7px solid $preload-color;
  transform: scale(0.3);
  display: block;
  border-radius: 50%;
  animation: #{$d}s more-preload infinite;
}

@for $i from 0 through 4 {
  .load-more-preload span:nth-child(#{$i + 1}) {
    animation-delay: #{($d/5.6) * $i}s;
  }
}

@keyframes more-preload {
  0% {
    transform: scale(0.3);
  }
  50% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.3);
  }
}
</style>
